<template>
  <div>
    <!-- section 1: -->
    <div class="uk-section uk-section-large uk-light uk-background-cover partyImage">
      <div class="uk-container">
        <img src="../../assets/logo.ee.png" style="width: 450px" class="uk-animation-scale-up">
        <div class="title">
          <h1 class="uk-heading-primary uk-animation-slide-bottom-medium">{{ title }}</h1>
          <span class="subtitle">{{ subtitle }}</span>
        </div>
      </div>
    </div>
    <!-- section 2: -->
    <div class="uk-section uk-section-default uk-section-xsmall">
      <div class="uk-container">
        <!--span uk-icon="icon: quote-right; ratio: 2"></span-->
        <blockquote cite="#" class="uk-text-large uk-align-center">
          <p>
            "The biggest impact on your visitors isn't the experience you've staged. The biggest impact is the transformation they feel by creating the experience together."
          </p>
          <footer><b>Richelle Beerens</b>, Founder of Experience Excellence
            <!-- <cite>
                      <a href="#">Source Title</a>
                    </cite> -->
          </footer>
        </blockquote>
      </div>
    </div>
    <!-- section 3: -->
    <div class="uk-section uk-section-xlarge">
      <div class="uk-container">
        <div class="uk-child-width-1-2@l" uk-grid>
          <div class="patua-one mint section-title ee-center">
            Marketing-Communicatie<br /> voor evenementen.
          </div>
          <div>
            <div class="uk-inline ee-center overflow-hidden">
              <img class="uk-responsive-height" src="../../assets/ruit-mint.png">
              <div class="uk-overlay uk-position-center">
                <span class="uk-visible@s">
                          Op het moment dat<br />
                          uw toekomstige bezoeker<br />
                          een kaartje koopt, bent u de aandacht<br />
                          voorlopig al kwijt. Ze zijn haast niet betrokken<br />
                          bij het event tot de dag zelf. Wij zien in de periode<br />
                          hiertussen de perfecte kans om een échte band op te<br />
                          bouwen met uw bezoekers. Marketing-Communicatie bij<br />
                          evenementen is niet alleen promotie maken voor<br />
                          de kaartverkoop. Het echte werk begint pas<br />
                          daarna! Streef naar loyale bezoekers,<br />
                          verleng de levensduur van uw<br />
                          event en maak het een<br />
                          ‘NeverEndig Experience!’
                        </span>
                  <span class="uk-hidden@s">
                          Op het moment dat
                          uw toekomstige bezoeker
                          een kaartje koopt, bent u de aandacht
                          voorlopig al kwijt. Ze zijn haast niet betrokken
                          bij het event tot de dag zelf. Wij zien in de periode
                          hiertussen de perfecte kans om een échte band op te
                          bouwen met uw bezoekers. Marketing-Communicatie bij
                          evenementen is niet alleen promotie maken voor
                          de kaartverkoop. Het echte werk begint pas
                          daarna! Streef naar loyale bezoekers,
                          verleng de levensduur van uw
                          event en maak het een
                          ‘NeverEndig Experience!’
                        </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- section 4: -->
    <div class="uk-section uk-background-cover uk-section-large bookImage">
      <div class="uk-container">
        <div class="patua-one mint section-title">Zo maken wij van eendagsvliegen<br />loyale bezoekers.</div>
      </div>
    </div>
    <!-- section 5: -->
    <div class="uk-section line-h">
      <div class="uk-container parent">
        <div class="uk-child-width-1-4@l" uk-grid>
          <div class="uk-inline">
            <img src="../../assets/ruit-paars-klein.png">
            <a href="#modal-doelen" uk-toggle>
              <img class="uk-overlay uk-position-center" style="margin-left: 20px; margin-top: -12px; cursor: pointer;" src="../../assets/icon.doelen.png">
            </a>
          </div>
          <div class="uk-inline">
            <img src="../../assets/ruit-paars-klein.png">
            <a href="#modal-uitdagen" uk-toggle>
              <img class="uk-overlay uk-position-center" style="margin-left: 20px; margin-top: -12px; cursor: pointer;" src="../../assets/icon.uitdagen.png">
            </a>
          </div>
          <div class="uk-inline">
            <img src="../../assets/ruit-paars-klein.png">
            <a href="#modal-betekenisgeven" uk-toggle>
              <img class="uk-overlay uk-position-center" style="margin-left: 20px; margin-top: -8px; cursor: pointer;" src="../../assets/icon.betekenisgeven.png">
            </a>
          </div>
          <div class="uk-inline">
            <img src="../../assets/ruit-paars-klein.png">
            <a href="#modal-herinneren" uk-toggle>
              <img class="uk-overlay uk-position-center" style="margin-left: 17px; margin-top: -8px; cursor: pointer;" src="../../assets/icon.herinneren.png">
            </a>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-doelen" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <img class="uk-align-left uk-margin-large-bottom" src="../../assets/icon.doelen.png">
        <div><h3 class="uk-card-title uk-margin-bottom">Doelen stellen</h3>
        <p>Wat is jouw doel? Loyale bezoekers? Bezoekers die meer geld uit geven? Bezoekers die elk jaar
        weer komen? Een frisse draai aan het huidige concept? Of gewoon zorgen dat die kaarten
        verkocht worden? Wij maken samen een actieplan voor jouw event!</p></div>
      </div>
    </div>
    <div id="modal-uitdagen" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <img class="uk-align-left uk-margin-large-bottom" src="../../assets/icon.uitdagen.png">
        <div><h3 class="uk-card-title uk-margin-bottom">Uitdagen</h3>
        <p>Mensen zijn pas echt gelukkig als ze zich bezighouden met dingen die hun volledige aandacht
        vragen. Dus iedereen moet voor het event uitgedaagd worden om betrokken te zijn!</p></div>
      </div>
    </div>
    <div id="modal-betekenisgeven" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <img class="uk-align-left uk-margin-large-bottom" src="../../assets/icon.betekenisgeven.png">
        <div><h3 class="uk-card-title uk-margin-bottom">Betekenis geven</h3>
        <p>Tijdens het event worden activiteiten opgezet die de bezoekers van binnen raken. Problemen
        worden opgelost en persoonlijke drijfveren worden geprikkeld om geluk te stimuleren. Bezoekers
        moeten naar huis gaan met het gevoel dat het event echt iets voor ze heeft betekent.</p></div>
      </div>
    </div>
    <div id="modal-herinneren" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <img class="uk-align-left uk-margin-large-bottom" src="../../assets/icon.herinneren.png">
        <div><h3 class="uk-card-title uk-margin-bottom">Herinneren</h3>
        <p>Na het event delen we waardevolle herinneringen, zodat telkens weer dat ultieme gevoel van geluk
        getriggerd wordt. Door de ogen van de bezoekers, maar ook door de ogen van de artiesten en
        jouw organisatie.</p></div>
      </div>
    </div>
    <!-- section 6: -->
    <div class="uk-section uk-light uk-section-large">
      <div class="uk-container">
        <div class="uk-inline">
          <img src="../../assets/kroon.png">
          <div class="uk-position-bottom uk-inline uk-visible@m" style="top:-10px;">
            <img src="../../assets/ruit-mint-open.png">
            <img class="uk-position-top" style="top: 220px" src="../../assets/ruit-mint-dicht-klein.png">
          </div>
          <div class="uk-position-bottom uk-inline uk-hidden@m" style="top:-10px;">
            <img src="../../assets/ruit-mint-open.png">
            <img class="uk-position-top" style="top: 100px" src="../../assets/ruit-mint-dicht-klein.png">
          </div>
        </div>
        <div class="uk-hidden@m"><br /><br /><br /></div>
        <div class="uk-child-width-1-2@m uk-margin-large-top" uk-grid>
          <div class="patua-one mint section-title ee-center">De voordelen van<br />loyale bezoekers.</div>
          <div class="uk-text-left ee-center">
            <ul>
              <li>Bereid om meer geld uit te geven</li>
              <li>Hoge betrokkenheid</li>
              <li>Overtuigende mond-tot-mond reclame</li>
              <li>Verlengt de levensduur van het event</li>
              <li>Sterke positie tegenover concurrent</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- section 7: -->
    <div class="uk-section uk-light uk-background-cover uk-section-large eventsImage" style="margin: 50px;">
      <div class="uk-container">
        <div class="uk-inline">
          <img src="../../assets/ruit-mint.png">
          <div class="patua-one mint section-title uk-overlay uk-position-center">
            Publiek &<br /> Business
            <br /> events
            <br />
          </div>
        </div>
      </div>
    </div>
    <!-- section 8: -->
    <div class="uk-section uk-section-large uk-background-cover laptopImage">
      <div class="uk-container">
        <div class="patua-one mint section-title">Onze klanten</div>
      </div>
    </div>
    <!-- section 9: -->
    <div class="uk-section line-h">
      <div class="uk-container">
        <div class="uk-child-width-1-3@l" uk-grid>
          <div class="uk-inline">
            <img src="../../assets/ruit-paars-klein.png">
            <img class="uk-overlay uk-position-center" style="margin-left: 20px; margin-top: -12px;" src="../../assets/logo.avonden.png">
          </div>
          <div class="uk-inline">
            <img src="../../assets/ruit-paars-klein.png">
            <img class="uk-overlay uk-position-center" style="margin-left: 17px; margin-top: -12px;" src="../../assets/logo.lzr.png">
          </div>
          <div class="uk-inline">
            <img src="../../assets/ruit-paars-klein.png">
            <img class="uk-overlay uk-position-center" style="margin-left: 20px;" src="../../assets/logo.angers.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      title: 'Experience Excellence',
      subtitle: 'The NeverEnding experience'
    }
  }
}
</script>

<style scoped>
.subtitle {
  font-size: 1.5em;
  text-shadow: 0px 2px 5px #000000;
  color: #ffffff;
}

.line-h {
  background-image: url(../../assets/lijn.horizontaal.png);
  background-repeat: repeat-x;
  background-position: center;
}

@media screen and (max-width: 1200px) {
  .line-h {
    background-image: url(../../assets/lijn.verticaal.png);
    background-repeat: repeat-y;
    background-position: center;
  }
  .line-h > div {
    margin-right: 1.5px;
  }
}

@media screen and (max-width: 640px) {
  .overflow-hidden {
    overflow: hidden;
  }
}

.partyImage {
  background-image: url(../../assets/Background.foto.png);
}

.bookImage {
  background-image: url(../../assets/boek.jpg);
}

.eventsImage {
  background-image: url(../../assets/publiek.event.businessfoto.jpg);
}

.laptopImage {
  background-image: url(../../assets/laptop.jpg);
}

.kroonImage {
  background-image: url(../../assets/kroon.png);
  background-repeat: no-repeat;
  background-position: center;
}

.smokeSection {
  background-image: url(../../assets/Background.foto.png);
}

.eventSection {
  background-image: url(../../assets/Background.foto.png);
  /* background-position: bottom; */
  padding-top: 0;
}

.overlayLines {
  border-top: 2px solid white;
  border-bottom: 2px solid white;
}

.iconLayout {
  text-transform: uppercase;
  line-height: 1em;
}

.bigButton {
  color: #ffffff !important;
  border: 1px solid #fff;
  width: 100px;
  height: 100px;
}

.bigButton-green {
  background-color: #55d6be;
}

.bigButton-grey {
  background-color: #777;
}

.bigText {
  font-size: 1.5em;
}

.ruit {
  background-image: url(../../assets/ruit-mint.png);
  background-position: center;
  color: black;
  margin: 0 auto 0 auto;
}

.ruit-paars {
  background-image: url(../../assets/ruit-paars-klein.png);
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 40px;
}

.ruit h1 {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue